
    import Vue from 'vue';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';
    import TabOne from './tabsClient/tab-oneClient.vue';
    import TabTwo from './tabsClient/tab-twoClient.vue';
    import { tabValidation, toViewModel } from '@/apps/shared/utils/NF';
    import DiscountRangeService from '@/apps/shared/services/getDiscountRange-service';
    import WhatsApp from '@/apps/shared/components/WhatsApp.vue';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper'; 
    export default Vue.extend({
        components: {
            TabOne,
            TabTwo,
            WhatsApp,
            XBreadcrumb
        },
        busEvents: {
            enablePrevButton() {
                this.$refs.wizard?.enableButton("prev");
            },
            disablePrevButton() {
                this.$refs.wizard?.disableButton("prev");
            },
            enableNextButton() {
                this.$refs.wizard?.showButton("next");
            },
            disableNextButton() {
                this.$refs.wizard?.hideButton("next");
            },
            redirectSummary() {
                if (this.$route.path !== '/movilidad/resumen') {
                    this.$router.push({ name: 'UrbanMobilitySummary' }).catch(err => {
                        // Si la redirección falla por cualquier motivo, no hacer nada.
                        if (err.name !== 'NavigationDuplicated') {
                            console.error('Error en la navegación:', err);
                        }
                    });
                }
            },
            redirectPlan() {
                if (this.$route.path !== '/movilidad/elegiPlan') {
                    this.$router.push({ name: 'plans-view' }).catch(err => {
                        // Si la redirección falla por cualquier motivo, no hacer nada.
                        if (err.name !== 'NavigationDuplicated') {
                            console.error('Error en la navegación:', err);
                        }
                    });
                }
            }
        },
        name: 'UrbanMobilityClientData',
        data() {
            return {
                referente: null,
                medium: null,
                rate: null,
                precioSinDescuento: null,
                stepOneData: null,
                stepTwoData: null,
                stepThreeData: null,
                DataPlan: null,
                planDescription: null,
                primerCuota: null,
                coberturasAmparo: null,
                responseDiscountRange: null,
                discountOff: null,
                activeStep: 0,
                breadcrumbItems: [
                    { text: 'Inicio', path: '/movilidad' },
                    { text: 'Datos personales', path: 'movilidad/datosCliente' },
                ],
                wizard: {
                    showStepName: false,
                    type: NF.Wizard.Type.PILLS,
                    mode: NF.Wizard.Mode.STEP_BY_STEP,
                    validationMode: NF.Wizard.ValidationMode.ALWAYS,
                    buttons: {
                        final: { text: 'Contratar', class: 'btn btn-default' },
                        prev: { text: 'Anterior', class: 'btn btn-secondary-outline' },
                        next: { text: 'Siguiente', class: 'btn btn-default' }
                    },
                    footer: {
                        align: NF.Wizard.Footer.Align.SPACE_BETWEEN,
                    },
                    steps: [
                        {
                            displayName: '',
                            content: '#step1',
                            viewModel: toViewModel(TabOne),
                            validate: (config, direction) => tabValidation(config, direction),
                            onEnter: function () {
                                this.Bus.$emit('updateBreadcrumb', { oldText: 'Contratar', newText: 'Datos personales' });
                                this.Bus.$emit('enablePrevButton');
                            },
                        },
                        {
                            displayName: '',
                            content: '#step2',
                            viewModel: toViewModel(TabTwo),
                            validate: (config, direction) => tabValidation(config, direction),
                            onEnter: function () {
                                var referente = sessionStorage.getItem("Referente");
                                referente == 'null' || referente == null ? this.referente = null : this.referente = referente;
                                var medium = sessionStorage.getItem("Medium");
                                medium == 'null' || medium == null ? this.medium = 'organic' : this.medium = medium;

                                this.Bus.$emit('updateBreadcrumb', { oldText: 'Datos personales', newText: 'Contratar' });
                                this.Bus.$emit('enablePrevButton');
                                window.globalThis.dataLayer.push({
                                    'pas': null,
                                    'email': JSON.parse(sessionStorage.getItem("stepOneData")).email,
                                    'product': 'movilidad',
                                    'event': 'cotizador-movilidad-datos-vehiculo',
                                    'referente': this.referente,
                                    'medio': this.medium
                                });
                            },
                        },
                    ],
                },
            };
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Movilidad urbana';
                const actualPath = '/movilidad';
                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, null, null);
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultUrbanMobilityGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            showFileError(errorMessage) {
                NF.Notification.show({
                    type: NF.Notification.Type.ERROR,
                    title: 'Error',
                    content: errorMessage,
                    position: NF.Notification.Positions.TOP_RIGHT,
                    clickClose: true,
                    autoHideDelay: 0
                })
            },
            open: function () {
                this.$refs.modal.open();
            },
            close: function () {
                this.$refs.modal.close();
            },
            getFilePath() {
                this.close();
                this.$router.push({ name: 'tabOne' });
            },
            async getUrbanMovilityDiscountRange() {
                NF.UI.Page.block();
                await DiscountRangeService.getUrbanMovilityDiscountRange().then((response) => {
                    if (response.length > 0) {
                        this.responseDiscountRange = response;
                        this.rate = this.responseDiscountRange[0].discountMaxValue;
                        this.discountOff = this.responseDiscountRange[0].discountMaxValue;
                    }
                }).finally(() => {
                    NF.UI.Page.unblock();
                });
            },
            getInitData() {
                sessionStorage.setItem("ExitOrContinueModal", "true");
                this.Bus.$on('step-one-data', (stepData) => this.stepOneData = stepData);
                this.Bus.$on('step-two-data', (stepData) => this.stepTwoData = stepData);
                var planDataSelected = sessionStorage.getItem("PlanSelected")
                if (planDataSelected != null) {
                    this.DataPlan = JSON.parse(planDataSelected!);
                    window.globalThis.dataLayer.push({
                        'pas': null,
                        'email': JSON.parse(sessionStorage.getItem("TabOneWelcome")).email,
                        'product': 'movilidad',
                        'event': 'cotizador-movilidad-plan',
                        'plan': this.DataPlan.planDescription,
                        'referente': this.referente,
                        'medio': this.medium
                    });
                    this.planDescription = this.DataPlan.planDescription;
                    this.primerCuota = this.DataPlan.premioMensual;
                    this.coberturasAmparo = this.DataPlan.groupOfAmparoTheftOptions;
                    this.precioSinDescuento = this.DataPlan.premiumWithoutDiscount;
                }
            }
        },
        async mounted() {
            try {
                NF.UI.Page.block();

                var referente = sessionStorage.getItem("Referente");
                referente == 'null' || referente == null ? this.referente = null : this.referente = referente;
                var medium = sessionStorage.getItem("Medium");
                medium == 'null' || medium == null ? this.medium = 'organic' : this.medium = medium;

                await this.pageCustomization();

                const parallelPromises = [
                    this.updateByProductGoogleAnalytics(),
                    this.getUrbanMovilityDiscountRange()
                ];

                await Promise.all([
                    ...parallelPromises,
                ]);

               this.getInitData();

            } finally {
                NF.UI.Page.unblock();
            }
        },
    })
